// extracted by mini-css-extract-plugin
export default {"root":"D5L290Wjq6","editorContainer":"XcG8YVESuc","footer":"H6cI42hzcK"};